import { useRef } from "react"

import { useTranslation } from "react-i18next"

import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog"

type AdminUnsavedChangesDialogProps = {
  open: boolean
  onCancel: () => void
  onDiscard: () => void
}

export function AdminUnsavedChangesDialog({
  open,
  onCancel,
  onDiscard,
}: AdminUnsavedChangesDialogProps) {
  const { t } = useTranslation()
  const confirmedRef = useRef(false)

  return (
    <AlertDialog
      open={open}
      onOpenChange={(nextOpen) => {
        if (!nextOpen) {
          if (confirmedRef.current) {
            confirmedRef.current = false
            return
          }
          onCancel()
        }
      }}
    >
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>
            {t("common.unsaved_changes_title", { defaultValue: "Discard unsaved changes?" })}
          </AlertDialogTitle>
          <AlertDialogDescription>
            {t("common.unsaved_changes_description", {
              defaultValue:
                "You have unsaved Admin Dashboard changes. If you continue, they will be lost.",
            })}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>{t("common.cancel", { defaultValue: "Cancel" })}</AlertDialogCancel>
          <AlertDialogAction
            onClick={() => {
              confirmedRef.current = true
              onDiscard()
            }}
          >
            {t("common.discard", { defaultValue: "Discard" })}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
